import {
    GETWALLETOWNERSETTING_SUCCESS,
    GETWALLETOWNERSETTING_FAILED,
    RESET_GETALLWALLETOWNERSETTING,
    LOADING_GETWALLETOWNERSETTING,
    NETWORK_ERROR_GETWALLETOWNERSETTING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetWalletOwnerSettingDetails = () => {
    return { type: RESET_GETALLWALLETOWNERSETTING };
};

const getWalletOwnerSettingDetails = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWALLETOWNERSETTING });
    await adminServices
        .post("getWalletOwnerSettingDetails", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getWalletOwnerSettingDetailssuccess(res.data));
                    break;
                default:
                    dispatch(getWalletOwnerSettingDetailsFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETWALLETOWNERSETTING, payload: err });
        });
};
function getWalletOwnerSettingDetailssuccess(data) {
    return {
        type: GETWALLETOWNERSETTING_SUCCESS,
        payload: data,
    };
}
function getWalletOwnerSettingDetailsFailed(data) {
    return {
        type: GETWALLETOWNERSETTING_FAILED,
        payload: data,
    };
}

export { resetGetWalletOwnerSettingDetails, getWalletOwnerSettingDetails };
